//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters, mapState} from 'vuex'

export default {
  name: 'Increase',
  computed: {
    ...mapGetters([
      'vcListNoSettleEnabled'
    ]),
    ...mapState({
      coinListWithPrice: state => state.vc.coinListWithPrice
    }),
    increaseCoinList () {
      if (!this.coinListWithPrice.length) return []
      return this.vcListNoSettleEnabled.map(settleItem => {
        return this.coinListWithPrice.find(coinWithPriceItem => {
          return settleItem.id === coinWithPriceItem.a
        })
      }).filter(item => !!item).sort((pre, next) => next.k - pre.k)
    }
  },
  methods: {
    clickVcItem (currency) {
      this.$store.dispatch('setVcId', currency.a)
          .then(() => {
            this.$router.push('/trade')
          })
          .catch(err => {
            this.$message.error(err.message)
          })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/Ranking/components/Increase/Increase.vue